<template>
  <div class="home" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px;">
    <ofr></ofr>
    <!-- <offr></offr> -->
    <trendingitems></trendingitems>
  </div>
  
  
</template>

<script>
// @ is an alias to /src
// import offr from '@/components/Items'
import trendingitems from '@/components/TrendingItems'
import ofr from '@/components/Ofr'
  import axios from 'axios';

export default {
   components: {      
        // offr,
        trendingitems,
        ofr
        
       },
        data: () => ({
            name: 'Home',
            products : []
        }),
        mounted() {
          
           this.getimgPath();
            this.$parent.$children[0].$parent.ttlval = this.name

            console.log(this.$el.textContent) 

       },
    methods: {
   
     getimgPath: function () {
     
      axios.get(this.$bURL+"Item/GetItemImageUrl")
      .then((response)  =>  {
      //  console.log(response.data)
        localStorage.setItem("imgUrl",response.data)
        // this.products = response.data;
      }, (error)  =>  {
          console.log(error)
      })
    }
  },

 
}
</script>
